import { createContext } from 'react';

export interface DownloadAccessContextValue {
  guardDownload: () => Promise<boolean>;
}

export const DownloadAccessContext = createContext<DownloadAccessContextValue | null>(null);
